import HappyLittleBlueCloud from './HappyLittleBlueCloud.svg';
import SalesforceDeleteIcon from './SalesforceDelete.svg';
import SalesforceSupportIcon from './SalesforceSupport.svg';
import salesforceTheme from './theme';

export default {
  icons: {
    logo: HappyLittleBlueCloud,
    delete: SalesforceDeleteIcon,
    support: SalesforceSupportIcon,
  },
  theme: salesforceTheme,
};
